import { Indicator } from '../../../Common/Charts/Indicator';
import { useDatabaseChartsDataContext } from './hooks/useDatabaseChartsDataContext';

export const BolsaFamiliaReceivingIndicator = () => {
    const { chartData } = useDatabaseChartsDataContext();

    return (
        <Indicator
            title={'Indice de Recebimento de Bolsa Família'}
            indicatorValue={chartData?.indicators?.bolsaFamiliaReceiving}
            className='aligned-container'
        />
    );
};
